import * as React from "react";
import {Button} from "@mui/material";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";

export default function TopDebtorsTableToggleButton({open, onClick}) {
    return (
        <Button variant="outlined" size="small" onClick={onClick}
               endIcon={
                   <KeyboardArrowDownIcon
                       sx={{transform: open ? 'none' : 'rotate(-90deg)', transition: 'transform 150ms ease'}}/>
               }>
            {open ? 'Ocultar Top 10' : 'Mostrar Top 10'}
        </Button>
    );
}
